import aragLogo from './arag-logo.svg';
import { useIntl } from '@/i18n';

const AragLogo = () => {
  const { t } = useIntl();

  return <img src={aragLogo} alt={t({ id: 'common.aragModal.aragDetails.image' })} />;
};

export default AragLogo;
